import PageHeader from "./page-header/page-header";
import ContentHeader from "./content-header/content-header";
import TopMetricCards from "./top-metric-cards/top-metric-cards";
import AverageTimeCard from "./average-time-card/average-time-card";
import SpecItemSources from "./spec-item-sources/spec-item-sources";
import ConflictResolutionPerf from "./conflict-resolution-perf/conflict-resolution-perf";
import LatestActivities from "./latest-activities/latest-activities";
import ProcessedSources from "./processed-sources/processed-sources";
import ContributionPerformance from "./contribution-performance/contribution-performance";

export default function DashboardPage() {
  return (
    <div>
      <PageHeader breadcrumbs={["Dashboard"]} />
      <ContentHeader />
      <TopMetricCards />
      <div className="w-full flex gap-[20px] items-stretch mb-[20px]">
        <div className="flex flex-col gap-[20px] w-full max-w-[336px] min-[1410px]:max-w-[376px] min-[1530px]:max-w-[476px] min-[1640px]:max-w-[576px]">
          <AverageTimeCard />
        </div>
        <div className="flex-1 flex flex-col justify-between h-full self-stretch">
          <SpecItemSources />
        </div>
      </div>
      <div className="w-full flex gap-[20px] items-stretch">
        <div className="flex flex-col gap-[20px] w-full max-w-[336px] min-[1410px]:max-w-[376px] min-[1530px]:max-w-[476px] min-[1640px]:max-w-[576px]">
          <div className="w-full border border-[#e5e5e5] bg-white rounded-[16px]  h-[399px]">
            <div className="border-b border-[#e4e4e7] h-[50px] flex items-center px-[20px] py-[16px]">
              <div className="flex items-start flex-1 h-full">
                <p className="text-[16px] font-[700] text-[#000000] leading-[24px]">
                  Şartname Süre Dağılımı (Token?)
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-1 flex flex-col justify-between h-full self-stretch">
          <ConflictResolutionPerf />
        </div>
      </div>
      <div className="w-full flex gap-[20px] items-stretch mb-[20px] h-[656px] mt-[20px]">
        <div className="flex flex-col gap-[20px] w-full max-w-[336px] min-[1410px]:max-w-[376px] min-[1530px]:max-w-[476px] min-[1640px]:max-w-[576px] h-full">
          <LatestActivities />
        </div>
        <div className="flex-1 flex flex-col justify-between h-full self-stretch">
          <ProcessedSources />
        </div>
      </div>
      <div className="w-full flex gap-[20px] items-stretch mb-[20px] h-[566px] mt-[20px]">
        <div className="flex flex-col gap-[20px] w-full shrink-0 max-w-[336px] min-[1410px]:max-w-[376px] min-[1530px]:max-w-[476px] min-[1640px]:max-w-[576px] h-full">
          <div className="w-full border border-[#e5e5e5] bg-white rounded-[16px]  h-[576px]">
            <div className="border-b border-[#e4e4e7] h-[50px] flex items-center px-[20px] py-[16px]">
              <div className="flex items-start flex-1 h-full">
                <p className="text-[16px] font-[700] text-[#000000] leading-[24px]">
                  Tedarik Başına Harcanan Zaman
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-1 flex flex-col justify-between h-full self-stretch">
          <ContributionPerformance />
        </div>
      </div>
    </div>
  );
}
